export const SESSION_USER = "napbus";
export const SESSION_CLIENT = "currentclientnapbus";
